import { FC } from "react";
import "./index.css";

type Props = {
  endereco: any;
  config: any;
  cnpj?: string;
};

const StoreInfoAddress: FC<Props> = ({ endereco, config, cnpj }) => {
  const openGoogleMaps = () => {
    if (endereco?.cep) {
      const cepFormated = endereco?.cep.replace(/(\w{5})(\w{3})/, "$1-$2");
      const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
        cepFormated
      )}`;
      window.open(googleMapsUrl, "_blank");
    } else {
      alert("Please enter a valid postal code");
    }
  };

  return (
    <div className="info-loja-endereco">
      <h4>Endereço</h4>
      <div className="endereco">
        <div className="endereco-info">
          <span>{endereco?.name}</span>
          <span>
            {endereco?.address?.street}, {endereco?.address?.number}
          </span>
          <span>{endereco?.address?.district}</span>
          <span>
            {endereco?.address?.city} - {endereco?.address?.state}
          </span>
          <span>{endereco?.address?.cep}</span>
          <span>{cnpj && `CNPJ: ${cnpj}`}</span>
        </div>
        <div
          className="endereco-button"
          style={{
            background: config?.webappcolor.webappbutton
              ? config?.webappcolor.webappbutton
              : "#67BF5F",
            color: config?.webappcolor.fontbutton
              ? config?.webappcolor.fontbutton
              : "#FFFFFF",
          }}
          onClick={() => openGoogleMaps()}
        >
          <span> Ver no mapa</span>
          {locationIcon}
        </div>
      </div>
    </div>
  );
};
const locationIcon = (
  <svg
    width="11"
    height="15"
    viewBox="0 0 11 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 6C10.5 8.40625 7.30078 12.6445 5.87891 14.4219C5.55078 14.832 4.92188 14.832 4.59375 14.4219C3.19922 12.6445 0 8.40625 0 6C0 3.10156 2.35156 0.75 5.25 0.75C8.14844 0.75 10.5 3.10156 10.5 6Z"
      fill="white"
    />
  </svg>
);

export { StoreInfoAddress };
